import { render, staticRenderFns } from "./WheelsetAxleMeasures.vue?vue&type=template&id=3b4c73d7&scoped=true"
import script from "./WheelsetAxleMeasures.vue?vue&type=script&lang=js"
export * from "./WheelsetAxleMeasures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c73d7",
  null
  
)

export default component.exports